(() => {
  const init = () => {
    const button = document.querySelector('.whatsapp-float');
    if (!button) return;

    const footer = document.querySelector('.footer-section, footer');
    const cartOverlay = document.querySelector('[data-cart-overlay]');
    const homepageHero = document.querySelector('.rxfh-hero');
    let footerVisible = false;
    let homepageHeroVisible = false;

    const syncVisibility = () => {
      const cartOpen = cartOverlay?.classList.contains('is-active') || false;
      button.classList.toggle('is-context-hidden', footerVisible || cartOpen);
      button.setAttribute('aria-hidden', footerVisible || cartOpen ? 'true' : 'false');
      button.tabIndex = footerVisible || cartOpen ? -1 : 0;
    };

    const syncHomepageHero = () => {
      document.body.classList.toggle('rx-floating-tools-clear-hero', homepageHeroVisible);
    };

    if (footer && 'IntersectionObserver' in window) {
      const footerObserver = new IntersectionObserver((entries) => {
        footerVisible = entries.some((entry) => entry.isIntersecting);
        syncVisibility();
      }, { threshold: 0.01 });
      footerObserver.observe(footer);
    }

    if (homepageHero) {
      const heroRect = homepageHero.getBoundingClientRect();
      homepageHeroVisible = heroRect.bottom > 0 && heroRect.top < window.innerHeight;
      syncHomepageHero();

      if ('IntersectionObserver' in window) {
        const heroObserver = new IntersectionObserver((entries) => {
          homepageHeroVisible = entries.some((entry) => entry.isIntersecting);
          syncHomepageHero();
        }, { threshold: 0.01 });
        heroObserver.observe(homepageHero);
      }
    }

    if (cartOverlay && 'MutationObserver' in window) {
      const cartObserver = new MutationObserver(syncVisibility);
      cartObserver.observe(cartOverlay, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }

    syncVisibility();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
